import { Switch } from "@headlessui/react";
import React, { useContext } from "react"
import { DiscadorContext } from "../../../DiscadorExpert";


export const SwitchButtonLoginExpert = () => {
  const { finalizarSessao, iniciarSessao, onCall, isLogged, onRinging } = useContext(DiscadorContext);
  return (
    <>
      <div className="mt-1 -ml-4 flex  select-none flex-col items-center rounded  text-primary text-sm">
        <Switch.Group>
          <div className="flex items-center">
            <Switch.Label className=" select-none px-4 text-blue-900">Login Discador: &nbsp;</Switch.Label>
            <Switch
              disabled={onRinging || onCall}
              checked={isLogged}
              onChange={() => {
                if (isLogged) return finalizarSessao();
                iniciarSessao();
              }}
              className={`${isLogged ? 'bg-primary' : 'bg-gray-200'
                } relative inline-flex h-6 w-10 select-none items-center  -ml-4 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2`}
            >
              <span
                className={`${isLogged ? 'translate-x-6' : 'translate-x-1'
                  } inline-block h-4 w-4 transform select-none rounded-full bg-white transition-transform`}
              />
            </Switch>
          </div>

        </Switch.Group>
      </div>
    </>
  )
}